import type { FaireProductEntity } from "../../entity_types/product";

export const p_afh4gsehm4: FaireProductEntity = {
  token: "p_afh4gsehm4",
  type: "product",
  name: "Solar Halloween Eyeball Lights Outdoor, 8 Pieces LED Eyes",
  brandToken: "b_9axhqqxgf7",
  brandName: "Heynemo",
  imageUrl:
    "https://cdn.faire.com/fastly/c4dd20cebb4410c7078106f6e1c256bbb2bd9070d67f05673eb44a49c1b68bd9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/29ca7bd7b7a035a4dbce1a85c7ad07b9c2e7496296d526db76eb6bb2ff7868fb.jpeg",
    "https://cdn.faire.com/fastly/e9067bdac7a2ab5cdab5f351a60e1c9d9c1ef72bf21f65f778f671934574f5a8.jpeg",
    "https://cdn.faire.com/fastly/4e8177d54b619b2d4ee6412146ae3fba7978cc78bd3a8b1f63b83570c5dc0e03.jpeg",
    "https://cdn.faire.com/fastly/45e6c1dc42445b0cc5dcf123d5347cbefa77d463ea335f4b1008841fe36c8bd6.jpeg",
    "https://cdn.faire.com/fastly/26194df7c923a26bfba85f199fa152818ab6171adadbbd05a78f16bf1ab48a19.jpeg",
    "https://cdn.faire.com/fastly/e9da15066d59340c03cba17715a5250876c6dc51a2569e16b8d78c34b41088e7.jpeg",
    "https://cdn.faire.com/fastly/54398c5110a8bd68719bfa2d613a8b445d98751abb6450720f335ec544e7da0a.jpeg",
  ],
  priceDollars: 17.63,
  description:
    "Bring spine-chilling fun to your Halloween with these solar-powered glowing eyeball lights! Each eyeball features a realistic 3D design with bloodshot details and eerie green glow. The flexible wires let them sway with the wind—just like haunted eyes following your every move.\n\nPowered by sunlight, they charge during the day and automatically light up at night with color-changing modes. No wiring, no hassle—just stake them into the ground and let the fright begin! Built with IP65 waterproof materials, they’re ready to withstand rain, wind, and spooky nights.\n\nPerfect for lining walkways, decorating gardens, or creating a creepy scene on your porch or lawn. Whether you’re hosting a Halloween party or setting up a haunted yard, these lights are the perfect way to scare and delight guests of all ages.",
  tags: [],
  msrpDollars: 33.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:42.564Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
